import { render, staticRenderFns } from "./CustomerGuarantorsModal.vue?vue&type=template&id=47d939bb&scoped=true&"
import script from "./CustomerGuarantorsModal.vue?vue&type=script&lang=js&"
export * from "./CustomerGuarantorsModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGuarantorsModal.vue?vue&type=style&index=0&id=47d939bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d939bb",
  null
  
)

export default component.exports